import { createFileRoute } from "@tanstack/react-router"
import { clearSocialMatchRequestDraft } from "@/features/social-match"

// Черновик запроса живёт, пока юзер внутри раздела; ушёл — стираем.
export const Route = createFileRoute("/_authenticated/social-match")({
	onLeave: clearSocialMatchRequestDraft,
})
